import { useQuery } from "@tanstack/react-query";
import type { DateTime } from "luxon";
import { backendService } from "../services/backend.service";
import type { NurseInShift } from "../utils/models";

export const useSwapOptions = (departmentId: string, start_time?: DateTime, end_time?: DateTime) => {
	return useQuery<Record<string, NurseInShift[]>>({
		queryKey: ["swapOptions", departmentId, start_time, end_time],
		queryFn: async () => {
			const response = await backendService.getSwapOptions(departmentId, start_time, end_time);
			return response.data;
		},
		enabled: !!departmentId && !!start_time && !!end_time,
	});
};
